// React
import React, { useEffect, useState } from "react";

// MUI
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Collapse,
  Autocomplete,
  Paper,
  Tooltip,
} from "@mui/material";

//MUI ICON
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";

// Formik
import { useFormik } from "formik";

//Components
import Dropzone from "components/Dropzone_one";
import {
  GradientButton,
  GradientButtonOutline,
  GradientShadow,
} from "components/GradientButton";

// Other
import { Divider } from "antd";
import Swal from "sweetalert2";
import { QRCodeCanvas } from "qrcode.react";

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field ของผู้ที่มาซื้อ
const customerFields = [
  {
    label: "ชื่อ-นามสกุล",
    name: "fullName",
    type: "text",
    // required: true,
    disabled: true,
  },
  {
    label: "เลขบัตรประชาชน",
    name: "idCardNumber",
    type: "text",
    // required: true,
    disabled: true,
  },
  {
    label: "เบอร์โทรศัพท์",
    name: "phoneNumber",
    type: "text",
    // required: true,
    disabled: true,
  },
  {
    label: "ที่อยู่",
    name: "address",
    type: "text",
    // required: true,
    disabled: true,
  },
];

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field หมวดหมู่
const categoryOptions = [
  { label: "เครื่องประดับ", id: 1 },
  { label: "อิเล็กทรอนิกส์", id: 2 },
  { label: "ทองคำ", id: 3 },
  { label: "พระเครื่อง", id: 4 },
  { label: "แบรนด์เนม", id: 5 },
  { label: "นาฬิกา", id: 6 },
];

const ViewBuyProduct = ({ open, onClose, selectedProduct }) => {
  // ตัวแปรสำหรับเก็บข้อมูลรูปภาพ
  const [files1, setFiles1] = useState([]);
  const [files2, setFiles2] = useState([]);
  const [error1, setError1] = useState(null);
  const [error2, setError2] = useState(null);
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);

  // ตัวแปรสำหรับเก็บข้อของ Box แสดง Product
  const [productBoxes, setProductBoxes] = useState([
    { id: 1, isExpanded: false },
  ]);
  const [expandedRow, setExpandedRow] = useState(null); // เก็บการแสดงผลของ Row ในการ Explaned

  //กรณีมีการส่งข้อมูลเข้ามาจะแสดง
  useEffect(() => {
    if (selectedProduct) {
      setExpandedBoxes(selectedProduct?.order_items[0].id);
      // ตรวจสอบว่า order_items มีข้อมูล และเป็นอาร์เรย์
      if (
        selectedProduct?.order_items &&
        Array.isArray(selectedProduct.order_items)
      ) {
        const formikValues = {};

        selectedProduct.order_items.forEach((pawn) => {
          console.log("check data inside 123", selectedProduct);
          const id = pawn.id; // ใช้ `id` แยกฟิลด์แต่ละ box
          const category_id = pawn.category_id;

          // เพิ่มฟิลด์สำหรับแต่ละ box
          formikValues[`product_code_${id}`] = pawn.product_code || "";
          formikValues[`product_name_${id}`] = pawn.product_name || "";
          formikValues[`category_id_${id}`] =
            categoryOptions.find((category) => category.id === category_id) ||
            null;
          formikValues[`detail_${id}`] = pawn.detail || "";
          formikValues[`blemishes_${id}`] = pawn.blemishes || "";
          formikValues[`size_${id}`] = pawn.size || "";
          formikValues[`total_amount_${id}`] =
            pawn.lenting_amount ||
            selectedProduct.lenting_amount ||
            pawn.total_amount ||
            1;
          formikValues[`price_${id}`] = pawn.product_price || 0;
          formikValues[`total_price_${id}`] = pawn.total_price || 0;

          // เก็บรูปภาพในฟิลด์ `images_${id}`
          formikValues[`images_${id}`] = Array.isArray(pawn.pictures)
            ? pawn.pictures.flatMap((picObj) =>
                Array.isArray(picObj.picture) ? picObj.picture : []
              )
            : [];
        });

        // เพิ่มข้อมูลลูกค้า
        formikValues.fullName = selectedProduct.customer_name || "";
        formikValues.idCardNumber = selectedProduct.idcard || "";
        formikValues.phoneNumber = selectedProduct.customer_phonenumber || "";
        formikValues.address = selectedProduct.customer_address || "";
        formikValues.product_images = selectedProduct.picture || [];
        formikValues.late_fees = selectedProduct.late_fees || 0;

        // ตั้งค่า Formik values
        formik.setValues(formikValues);
      }
    }
  }, [selectedProduct]);

  //ฟังก์ชันแสดง Explanded
  const handleExpandClick = (rowId) => {
    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  // ฟังก์ชัน explan
  const toggleExpand = (id) => {
    setExpandedBoxes((prevId) => (prevId === id ? null : id)); // หาก id ซ้ำให้ปิด, หากต่างให้เปิด
  };

  // Formik hook
  const formik = useFormik({
    initialValues: {
      payment_channel: "",
      notes_condition: "",
    },
    onSubmit: async (values) => {
      try {
        console.log("Submitting values:", values);

        alert("Order submitted successfully.");
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("An error occurred. Please try again.");
      }
    },
  });

  console.log("display work", selectedProduct);

  // ฟังก์ชันช่วยสำหรับแมปค่า
  const mapSelectedProductToField = (selectedProduct, fieldName) => {
    const mapping = {
      fullName: selectedProduct.customer_name,
      idCardNumber: selectedProduct.idcard,
      phoneNumber: selectedProduct.phonenumber,
      address: selectedProduct.address,
    };

    return mapping[fieldName];
  };

  // ฟังก์ชันการแสดงฟิลด์ Customer
  const renderFields = (fields, selectedProduct) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
          <Box display="flex" alignItems="center">
            <Typography
              variant="subtitle1"
              sx={{ width: "200px", whiteSpace: "nowrap" }}
            >
              {field.label}
              {field.required && (
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              )}
            </Typography>

            {field.type === "autocomplete" ? (
              <Autocomplete
                id={field.name}
                options={categoryOptions}
                getOptionLabel={(option) => option.label}
                value={formik.values.category_id}
                onChange={(event, newValue) => {
                  if (!field.disabled) {
                    formik.setFieldValue("category_id", newValue);
                  }
                }}
                disabled={field.disabled}
                fullWidth
                sx={{
                  flexGrow: 1,
                  ".MuiAutocomplete-inputRoot": {
                    height: "40px",
                    padding: "0px !important", // Ensure consistent padding
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name={field.name}
                    error={
                      formik.touched[field.name] &&
                      Boolean(formik.errors[field.name])
                    }
                    helperText={
                      formik.touched[field.name] && formik.errors[field.name]
                    }
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                )}
              />
            ) : (
              <TextField
                disabled={field.disabled}
                id={field.name}
                name={field.name}
                type={field.type}
                value={
                  selectedProduct
                    ? mapSelectedProductToField(selectedProduct, field.name)
                    : ""
                }
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched[field.name] &&
                  Boolean(formik.errors[field.name])
                }
                helperText={
                  formik.touched[field.name] && formik.errors[field.name]
                }
                fullWidth
                InputProps={{ sx: { height: "40px", padding: "0px" } }} // Ensure consistent height
              />
            )}
          </Box>
        </Grid>
      </React.Fragment>
    ));
  };

  const [expandedBoxes, setExpandedBoxes] = useState();

  // ฟังก์ชันการแสดงฟิลด์ของ Product

  // console.log("selectedProduct5365", selectedProduct);
  const renderProductBoxes = () => {
    return selectedProduct?.order_items.map((box) => (
      <Box
        key={box.id}
        sx={{
          my: 2,
          border: "1px solid #ddd",
          p: 2,
          borderRadius: "12px",
          backgroundColor: "#ffffff",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          onClick={() => toggleExpand(box.id)}
        >
          {/* ชื่อสินค้า */}
          <Typography variant="subtitle1">{box.product_name}</Typography>

          {/* ส่วนที่อยู่ด้านขวา */}
          <Box display="flex" alignItems="center" gap={1}>
            <Typography
              sx={{
                border: "1px solid #00BB9F",
                padding: "8px",
                borderRadius: "8px",
                backgroundColor: "rgba(0, 187, 159, 0.04)",
                display: "flex",
                alignItems: "center",
              }}
            >
              {box.total_amount} ชิ้น
            </Typography>
            <Typography
              sx={{
                border: "1px solid #00BB9F",
                padding: "8px",
                borderRadius: "8px",
                backgroundColor: "rgba(0, 187, 159, 0.04)",
                display: "flex",
                alignItems: "center",
              }}
            >
              {box.total_price} บาท
            </Typography>
            <IconButton
              size="small"
              color="default"
              onClick={() => handleExpandClick(box.id)}
              style={{
                transform: expandedRow === box.id ? "rotate(180deg)" : "none",
                transition: "transform 0.2s ease-in-out",
                marginLeft: "10px",
              }}
            >
              <ExpandMoreIcon />
            </IconButton>
          </Box>
        </Box>

        <Collapse in={expandedBoxes === box.id}>
          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Divider sx={{ borderColor: "#00BB9F", borderWidth: 1 }} />

            {/* Product QRCode Row */}
            <Grid item xs={12}>
              <Grid container alignItems="top">
                <Grid item xs={2}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>QR Code {""}</Typography>
                  </div>
                </Grid>

                <Grid item xs={10}>
                  <QRCodeCanvas
                    value={formik.values[`product_code_${box.id}`] || ""} // ดึงค่าจาก formik และใช้ค่าที่ว่างเป็นค่า default ถ้าไม่พบ
                    size={64} // ขนาดของ QR Code
                    bgColor={"#ffffff"} // สีพื้นหลัง
                    fgColor={"#000000"} // สีของ QR Code
                    level={"H"} // ระดับการกู้คืนข้อมูล (L, M, Q, H)
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* Product Code Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>รหัสสินค้า {""}</Typography>
                  </div>
                </Grid>

                <Grid item xs={10}>
                  <Typography>
                    {formik.values[`product_code_${box.id}`] || ""}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* Product Code2 Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>รหัส 2 {""}</Typography>
                    <Tooltip title="รหัสสินค้าภายในร้านที่สามารถกำหนดเองได้">
                      <InfoIcon style={{ color: "#e5e5e5", marginRight: 10 }} />
                    </Tooltip>
                  </div>
                </Grid>

                <Grid item xs={10}>
                  <Typography>
                    {formik.values[`product_code_com_${box.id}`] || ""}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Product Name Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    ชื่อสินค้า{""}
                    {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography>
                    {formik.values[`product_name_${box.id}`] || ""}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Product Category Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    หมวดหมู่{""}
                    {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography>
                    {
                      (
                        categoryOptions.find(
                          (option) =>
                            option.id ===
                            formik.values[`category_id_${box.id}`]?.id
                        ) || { label: "" }
                      ).label
                    }
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Product Detail Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>รายละเอียด</Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography>
                    {formik.values[`detail_${box.id}`] || ""}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Product Blemishes Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>ตำหนิ</Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography>
                    {formik.values[`blemishes_${box.id}`] || ""}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Product Size Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>ขนาด</Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography>
                    {formik.values[`size_${box.id}`] || ""}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Product Total amount Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    จำนวน{" "}
                    {/* <span style={{ color: "red", marginLeft: "3px" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography>
                    {formik.values[`total_amount_${box.id}`] || ""}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Product Price Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    ราคาทุน{""}
                    {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography>
                    {formik.values[`price_${box.id}`] || ""}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Product Total Price Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    ราคารวม{""}
                    {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography>
                    {formik.values[`total_price_${box.id}`] || ""}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Product Notes Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>หมายเหตุ</Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography>
                    {formik.values[`notes_${box.id}`] || ""}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Product Image Row */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 2 }}>
                รูปทรัพย์
              </Typography>
              <Grid item xs={12}>
                <div>
                  {Array.isArray(formik.values[`images_${box.id}`]) &&
                  formik.values[`images_${box.id}`].length > 0 ? (
                    <div>
                      {formik.values[`images_${box.id}`].map(
                        (imageUrl, index) => (
                          <img
                            key={index}
                            src={imageUrl}
                            alt={`Image ${index + 1} for Box ${box.id}`}
                            style={{
                              width: "150px",
                              height: "150px",
                              objectFit: "cover",
                              marginRight: "10px",
                            }}
                          />
                        )
                      )}
                    </div>
                  ) : (
                    <p>No images available for Box {box.id}</p>
                  )}
                </div>
              </Grid>

              {error1 && (
                <Typography variant="caption" color="error">
                  {error1}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Collapse>
      </Box>
    ));
  };

  //กรณีปิดหน้าต่าง Modal
  const handleCancel = () => {
    const formHasUnsavedChanges = Object.keys(touched).some(
      (field) => touched[field]
    );

    // console.log('formHasUnsavedChanges', formHasUnsavedChanges);
    // Prompt the user to confirm before closing if there are unsaved changes
    if (formHasUnsavedChanges) {
      Swal.fire({
        title: "Cancel",
        text: "If you cancel now, your information fills will be discarded.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0066FF",
        cancelButtonColor: "#0066FF",
        reverseButtons: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Keep Editing",
        customClass: {
          confirmButton: "confirm-rounded-button",
          cancelButton: "outlined-button",
          container: "swal2-container-custom", // Add custom class for container
        },
        didOpen: () => {
          // Set z-index in didOpen to ensure it's applied after dialog is rendered
          document.querySelector(".swal2-container-custom").style.zIndex = 1500; // or a higher value
        },
        iconHtml:
          '<svg width="150" height="150" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.4339 0.666016C36.3209 0.666016 46.7673 11.1123 46.7673 23.9993C46.7673 36.8863 36.3209 47.3327 23.4339 47.3327C10.5469 47.3327 0.100586 36.8863 0.100586 23.9993C0.100586 11.1123 10.5469 0.666016 23.4339 0.666016ZM23.4339 5.33268C18.4832 5.33268 13.7353 7.29934 10.2346 10.8C6.73391 14.3007 4.76725 19.0486 4.76725 23.9993C4.76725 28.9501 6.73391 33.698 10.2346 37.1987C13.7353 40.6994 18.4832 42.666 23.4339 42.666C28.3846 42.666 33.1326 40.6994 36.6332 37.1987C40.1339 33.698 42.1006 28.9501 42.1006 23.9993C42.1006 19.0486 40.1339 14.3007 36.6332 10.8C33.1326 7.29934 28.3846 5.33268 23.4339 5.33268ZM23.4339 30.9993C24.0528 30.9993 24.6462 31.2452 25.0838 31.6828C25.5214 32.1203 25.7673 32.7138 25.7673 33.3327C25.7673 33.9515 25.5214 34.545 25.0838 34.9826C24.6462 35.4202 24.0528 35.666 23.4339 35.666C22.8151 35.666 22.2216 35.4202 21.784 34.9826C21.3464 34.545 21.1006 33.9515 21.1006 33.3327C21.1006 32.7138 21.3464 32.1203 21.784 31.6828C22.2216 31.2452 22.8151 30.9993 23.4339 30.9993ZM23.4339 9.99935C24.0528 9.99935 24.6462 10.2452 25.0838 10.6828C25.5214 11.1204 25.7673 11.7138 25.7673 12.3327V26.3327C25.7673 26.9515 25.5214 27.545 25.0838 27.9826C24.6462 28.4202 24.0528 28.666 23.4339 28.666C22.8151 28.666 22.2216 28.4202 21.784 27.9826C21.3464 27.545 21.1006 26.9515 21.1006 26.3327V12.3327C21.1006 11.7138 21.3464 11.1204 21.784 10.6828C22.2216 10.2452 22.8151 9.99935 23.4339 9.99935Z" fill="#ED4040"/></svg>',
      }).then(async (result) => {
        if (result.isConfirmed) {
          formik.resetForm();
          setFiles1([]); // Clear product images
          setFiles2([]); // Clear customer images
          setInitialProductUrls([]); // Clear initial product image URLs
          // setInitialCustomerUrls([]);
          setDeletedImageIds([]);
          onClose();
        }
      });
    } else {
      formik.resetForm();
      setFiles1([]); // Clear product images
      setFiles2([]); // Clear customer images
      setInitialProductUrls([]); // Clear initial product image URLs
      // setInitialCustomerUrls([]);
      setDeletedImageIds([]);
      onClose();
    }
  };

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        //ป้องกันการกดเบื้องหลังแล้วหลุด
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      fullWidth
      maxWidth="lg"
      sx={{
        borderRadius: "8px",
      }}
    >
      <>
        {/* หน้าที่ 1 : Form */}
        <DialogTitle style={{ backgroundColor: "#F1F2F7" }}>
          <Typography variant="h4">ดูรายละเอียดสินค้า</Typography>
        </DialogTitle>
        <DialogContent style={{ backgroundColor: "#F1F2F7" }}>
          <form onSubmit={formik.handleSubmit}>
            {/* Render the product boxes */}
            <Grid item xs={12} sx={{ mx: 2 }}>
              <Typography sx={{ mb: 1, ml: 2 }} variant="h5">
                ข้อมูลลูกค้า
              </Typography>
              <Paper sx={{ p: 2, borderRadius: "12px" }}>
                <Grid container>
                  <Grid item xs={7}>
                    {renderFields(customerFields, selectedProduct)}
                  </Grid>
                  <Grid item xs={5} sx={{ mt: 2 }}>
                    {selectedProduct ? (
                      <img
                        src={selectedProduct.customer_image}
                        alt="Preview"
                        style={{
                          width: "200px",
                          height: "200px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <Dropzone
                        files={files2}
                        setFiles={setFiles2}
                        setError={setError2}
                      />
                    )}
                    {error2 && (
                      <Typography variant="caption" color="error">
                        {error2}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Paper>

              <Grid items xs={12}>
                {/* Render the product boxes */}
                <Typography sx={{ mb: 2, mt: 3, ml: 2 }} variant="h5">
                  ข้อมูลสินค้า
                </Typography>
                {renderProductBoxes()}
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </>

      <DialogActions
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0 16px 16px 16px",
          backgroundColor: "#F1F2F7",
        }}
      >
        {/* Dialog Actions */}
        <Grid container sx={{ mx: 3 }}>
          <Grid item xs={12}>
            <Divider
              style={{
                marginTop: "0",
                marginBottom: "16px",
              }}
            />
          </Grid>

          <Grid
            item
            xs={12}
            container
            justifyContent="space-between" // Apply flex properties to align buttons
          >
            <GradientShadow
              onClick={handleCancel}
              sx={{
                borderRadius: "12px", // Make the button circular
                minWidth: "150px", // Adjust the width
                minHeight: "20px", // Adjust the height
                padding: 0, // Remove padding to center the icon better
                borderColor: "#c4c4c4", // Light grey border
                color: "#6c6c6c", // Light grey icon color
                display: "flex", // Ensure flexbox is used
                alignItems: "center", // Center vertically
                justifyContent: "center", // Center horizontally
                "&:hover": {
                  borderColor: "#a0a0a0", // Darker grey on hover
                },
              }}
            >
              กลับ
            </GradientShadow>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ViewBuyProduct;
